export const values = {
  'forgot_password': 'Elfelejtett jelszó',

  /** Common */
  'price_list': 'Pirce list',
  'language': 'Languages',
  'details': 'Details',
  'add': 'Add',
  'save': 'Save',

  // Orderer
  'orderer_info': 'Orderer info',
  'project_name': 'Project name',
  'phone': 'Phone',
  'email': 'E-mail',
  'country': 'Country',
  'zip': 'ZIP code',
  'city': 'City',
  'address': 'Address',

  // Dimensions
  'cover_dimensions': 'Cover dimensions',
  'cover_type': 'Cover type',
  'length': 'Length',
  'inner_width': 'Inner width',
  'outer_width': 'Outer width',
  'add_segment': 'Add extra segment',
  'segment_count': 'Segment count',
  'segment_length': 'Segment length',
  'height': 'Height',
  'rail_width': 'Rail width',
  'rubber_height': 'Rubber height',
  'rear_rubber_height': 'Rubber height on rear wall',
  'walkable_side': 'Walkable side',
  'rail_side': 'Rail side',
  'no_rail': 'Without rails',
  'left_side': 'Left side',
  'right_side': 'Right side',
  'left': 'Left',
  'right': 'Right',

  // Doors
  'doors': 'Doors',
  'side_doors': 'Side doors',
  'door_placement': 'Door placement',
  'sliding_and_opening_doors': 'Sliding and opening doors',
  'door_type': 'Door type',
  'door_size': 'Door size',
  'door_position': 'Door position',
  'in_center': 'In center',
  'from_left': 'From left',
  'from_right': 'From right',
  'open_direction': 'Opening direction',
  'variation': 'Option',
  'with_sill': 'With sil',
  'without_sill': 'Without sil',
  'right-to-left': 'Right to left',
  'left-to-right': 'Left to right',
  'folding_doors': 'Folding doors',
  'framed': 'With frame',
  'frameless': 'Without frame',
  'other_doors': 'Other doors',

  // Options
  'options': 'Options',
  'painting': 'Powder coating',
  'glazing': 'Glazing',
  'increase_height': 'Height increase',
  'rail_extension': 'Rail extension',
  'other_technical_info': 'Other technical information',

  // Pricing
  'pricing_options': 'Pricing options',
  'custom_shipping_price': 'Custom shipping price',
  'custom_install_price': 'Custom installation price',
  'discount': 'Discount',

  // Blueprint
  'blueprint': 'Blueprint',

  // PDF
  'item_name': 'Item name',
  'net_amount': 'Net. value',
  'vat': 'VAT',
  'vat_amount': 'VAT value',
  'gross_amount': 'Gross value',
  'in_base_price': 'In base price',
  'total': 'Total',
  'discounted_price': 'Discounted price',
  'shipping_price': 'Shipping price',
  'install_price': 'Installation price',
  'final_total': 'Total price',

  'type_cover': 'pool cover',
  'outer_dimensions': 'Outer dimensions',

  'actions': 'Actions',
  'date': 'Date',
  'identifier': 'Identifier',
  'type': 'Type',
  'price': 'Price',
  'download': 'Download',
  'only_download_bid': 'Only download bid',
  'only_download_order': 'Only download order',
  'only_download_blueprint': 'Only download blueprint',
  'edit': 'Edit',
  'version_history': 'Version history',
  'show_revision_history': 'Check version history',

  'base_price': 'Base price',
  'logout': 'Logout',
  'create': 'Create',
  'status': 'Status',

  'other_data': 'Other information',
  'installable_from': 'Installable from',
  'pavement': 'Pavement around pool',

  'partners': 'Partners',
  'new_partner': 'New partner',
  'partner_list': 'Partner list',
  'events': 'Events',
  'manage_employees': 'Manage employees',
  'add_payment': 'Add payment',
  'add_expense': 'Add expense',
  'add_nivobidid': 'Add NivoBid ID',
  'add_production_date': 'Add production date',
  'change_status': 'Change status',

  'debt': 'Debt',
  'amount': 'Amount',
  'send': 'Send',
  'request_modification': 'Modification request',
  'request_from': 'Modification starts at',
  'request_to': 'Modification ends at',

  'name': 'Name',
  'available_pricelists': 'Available price lists',
  'available_languages': 'Available languages',
  'password': 'Password',
  'permissions': 'Permissions',

  'customer_bids': 'Customer bids',
  'company_customer_bids': 'Company customer bids',
  'supplier_bids': 'Supplier bids',
  'company_supplier_bids': 'Company supplier bids',
  'customer_orders': 'Customer orders',
  'company_customer_orders': 'Company customer orders',
  'supplier_orders': 'Supplier orders',
  'company_supplier_orders': 'Company supplier orders',
  'employees': 'Employees',
  'order_status': 'Order status',
  'order_payments': 'Order payments',
  'order_expenses': 'Order expenses',
  'nivobidid': 'NivoBid ID',
  'production_date': 'Production date',
  'save_partner': 'Save partner',
  'delete': 'Delete',
  'company_info': 'Company info',
  'app_configuration': 'Configure Application',
  'primary_user': 'Primary user',
  'view': 'View',
  'user_info': 'User information',
  'new': 'New',
  'tos': 'You automatically accept or T.O.S by submitting your order',
  'added_doors': 'Added doors',
  'no_doors_added': 'No doors added',
  'user': 'User',
  'data': 'Data',
  'old_value': 'Old value',
  'new_value': 'New value',
  'weight': 'Weight',
  'filter': 'Filter',
  'shipping_address': 'Shipping address',
  'note': 'Note',
  'apply_special_solutions': 'Apply special solutions',
  'wall_side': 'Wall side',
  'apply_custom_vat': 'Apply custom VAT',
  'pricelist': 'Price list',
  'datasheet': 'Datasheet',
  'terms_of_services': 'T.O.S.',
  'user_manual': 'User manual',
  'manage_invoices': 'Manage invoices',
  'transports': 'Transports',
  'lock_side': 'Lock side',

  /** Vouchers */
  'bids': 'Bids',
  'create_customer_bid': 'Create customer bid',
  'create_supplier_bid': 'Create supplier bid',
  'customer_bids_list': 'Customer bids list',
  'supplier_bids_list': 'Supplier bids list',
  'save_bid': 'Save bid',
  'save_bid_as_new': 'Save bid as new',
  'edit_bid': 'Edit bid',
  'delete_bid': 'Delete bid',

  'orders': 'Orders',
  'create_customer_order': 'Create customer order',
  'create_supplier_order': 'Create supplier order',
  'customer_orders_list': 'Customer orders list',
  'supplier_orders_list': 'Supplier orders list',
  'orders_list': 'Orders list',
  'save_order': 'Save order',
  'edit_order': 'Edit order',
  'delete_order': 'Delete order',

  'bid': 'Bid',
  'order': 'Order',
  'bid_issuer': 'Bid Issuer',
  'supplier': 'Supplier',
  'bid_recipient': 'Recipient',
  'orderer': 'Orderer'
};


// WEBPACK FOOTER //
// D:/Projects/bid/frontend/src/app/shared/locales/en.ts